import React from "react"
import PropTypes from "prop-types"
import { Section, CmsImage } from "@bw/bits"
import { Teasers } from "@bw/modules"
import { Teaser } from "@bw/partials"
import dateFormat from "../../../utils/dateFormat"

const News = ({ news }) => {
  if (!news) {
    return null
  }

  return (
    <Section>
      <Teasers>
        {news.map((item, k) => (
          <Teaser
            key={k}
            title={item.title}
            suptitle={dateFormat(item.date)}
            excerpt={item.teaserExcerpt}
            image={
              <CmsImage
                src={item.teaserImage || "/placeholder-teaser.jpg"}
                alt={item.title}
              />
            }
            to={item.slug}
          />
        ))}
      </Teasers>
    </Section>
  )
}

News.propTypes = {
  news: PropTypes.array,
}

export { News }
